import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LogCategory, LoggerService, LogType, LogWidget } from '../../../core/services/logger.service';
import { TagManagerService } from '../../../core/services/tag-manager.service';
import { CareersService } from '../../../services/careers.service';
import { IWidgetComponent } from '../../../shared/widget/i-widget-component';
import { Widget } from '../../../shared/widget/widget';


@Component({
    selector: 'app-events',
    templateUrl: './events.component.html',
    styleUrls: ['./events.component.scss'],
    standalone: false
})
export class EventsComponent implements OnInit, OnDestroy, IWidgetComponent {
    public data: Widget;
    
    public events: any[];
    public modalTitle: string;
    public dateType: string;
    
    public careerData$: Observable<any>;

    @HostBinding('class')
    get size(): string {
        var widgetSize = 'col-md-' + this.data.Size.toString();

        switch (this.data.Size) {
            case 4: {
                widgetSize += ' widget-small';
                break;
            }
            case 6: {
                widgetSize += ' widget-medium';
                break;
            }
            case 12: {
                widgetSize += ' widget-large';
                break;
            }
        }

        return widgetSize;
    }

    constructor(
        private logger: LoggerService,
        public careers: CareersService,
        private gtm: TagManagerService,        
        private modalService: NgbModal
    ) {
        this.log("constructor", null, LogCategory.Constructor);
          
        this.careerData$ = this.careers.events$.pipe(
            map((content => {
                let events = content.events;
                let data = {                   
                    baseUrl: content.baseUrl,
                    allCount: events.length,
                    firstRow: [],
                    secondRow: []
                };
                data.firstRow.push({
                    title: 'Events this week',
                    data: events.filter(event => event.IsThisWeek)              
                });
                data.firstRow.push({
                    title: 'Recently Added',
                    data: events.filter(event => event.IsRecentlyAdded).sort(function (a, b) {
                        if (a.CreatedDate > b.CreatedDate) { return -1; } if (a.CreatedDate < b.CreatedDate) { return 1; } return 0
                    })                    
                });
                data.firstRow.push({
                    title: 'Recently Updated',
                    data: events.filter(event => event.IsRecentlyUpdated).sort(function (a, b) {
                        if (a.ModifiedDate > b.ModifiedDate) { return -1; } if (a.ModifiedDate < b.ModifiedDate) { return 1; } return 0
                    })
                    
                });

                data.secondRow.push({
                    title: 'Conferences & Career Fairs',
                    data: events.filter(event => (event.EventTypeName == "Conferences & Career Fairs"))                    
                });
                data.secondRow.push({
                    title: 'Workshops',
                    data: events.filter(event => (event.EventTypeName == "Workshop")),                    
                });
                data.secondRow.push({
                    title: 'Other',
                    data: events.filter(event => (event.EventTypeName != "Conferences & Career Fairs") && (events.EventTypeName != "Workshop"))                    
                });

                return data;
            })
            ));



    }
    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.Widget, LogWidget.Events, category);
    }

    ngOnInit(): void {
        this.log("ngOnInit", null, LogCategory.Init);
    }

    ngOnDestroy() {
        this.log("ngOnDestroy", "", LogCategory.Destroy);
    }
    
    public openModal(events, content) {
        this.gtm.gaLinkClicked('Career Events', events.title);        
        this.events = events.data;
        this.modalTitle = events.title;       
        this.modalService.open(content, { size: 'lg', scrollable:true });
    }
}
